var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRokect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 441,
    viewBox: "0 0 409 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.757 13.3638H186.72",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 100.846L204.166 100.846",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 106.903L204.166 106.903",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.277 147.05V150.08L206.822 150.458L204.925 62.5953C204.015 42.5988 195.191 24.4707 190.893 17.9063C188.465 12.1497 180.02 4.90352 176.101 2C171.854 5.63572 163.459 18.9162 159.793 25.1019C145.533 49.643 146.519 84.8135 148.794 99.3311V116.374M147.277 147.05C142.726 146.671 132.941 146.747 130.21 150.08C127.935 141.495 128.466 122.736 148.794 116.374M147.277 147.05L151.449 145.156V116.374H148.794",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.478 14.499L181.41 19.8011",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.72 149.323L207.202 142.506",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.065 22.4491L190.892 16.7683",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.685 32.2991L193.925 23.5885",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.479 56.1585L201.891 45.5543",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.35 97.8465C194.281 97.8551 194.297 97.8576 194.374 97.8043C195.233 97.2085 196.218 96.7253 197.119 96.1899C198.479 95.3815 199.9 94.6739 201.257 93.8647C201.935 93.4606 202.563 92.9671 203.254 92.5877C203.707 92.3391 204.159 92.082 204.394 91.6118",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.076 96.1673C188.781 94.4649 191.06 93.7913 193.154 92.7458C194.825 91.9113 196.291 90.7496 197.874 89.77C199.492 88.7686 201.252 87.9686 202.769 86.8123C203.548 86.2193 204.465 85.6882 205.155 84.9991",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.759 89.1742C188.683 89.2502 188.948 89.064 188.973 89.0507C190.166 88.4157 191.278 87.5496 192.379 86.7707C194.145 85.5205 195.964 84.3831 197.784 83.2106C199.116 82.3523 200.338 81.3427 201.681 80.4999C202.419 80.0364 203.128 79.5396 203.798 78.9819",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.456 84.73C187.466 84.6345 187.555 84.6001 187.631 84.5553C188.064 84.2976 188.494 84.05 188.904 83.7542C190.073 82.9089 191.198 82.057 192.399 81.2573C194.228 80.0401 196.092 78.8794 197.916 77.6551C199.227 76.7752 200.599 75.9693 201.885 75.0498C202.477 74.6268 203.075 74.2145 203.635 73.7486C203.755 73.6489 204.306 73.1348 204.123 73.074",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.053 76.6768C188.196 76.6626 188.358 76.5849 188.482 76.5202C189.195 76.1461 189.858 75.6587 190.515 75.195C191.539 74.4716 192.632 73.8487 193.658 73.1288C195.332 71.9536 197.047 70.8349 198.731 69.6711C199.891 68.869 201.019 68.0642 202.2 67.2978C202.854 66.8728 203.572 66.4398 204.124 65.8882",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.325 69.6834C188.25 69.6727 188.369 69.5836 188.391 69.5629C188.792 69.1893 189.265 68.8778 189.682 68.5208C190.704 67.6462 191.762 66.891 192.864 66.1263C194.742 64.8232 196.744 63.7093 198.61 62.3946C199.83 61.5354 201.003 60.6265 202.242 59.7923C202.511 59.6108 204.591 57.7896 204.449 57.6478",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.944 62.8539C188.366 62.8539 188.862 62.3181 189.166 62.0859C189.999 61.4488 190.865 60.8457 191.748 60.2787C193.472 59.1719 195.139 57.968 196.77 56.7247C197.978 55.8031 199.185 54.8781 200.365 53.9206C201.268 53.1881 202.267 52.5638 203.092 51.74",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.944 112.297C187.832 112.311 188.053 112.204 188.128 112.143C188.943 111.479 189.803 110.868 190.616 110.201C191.6 109.394 192.662 108.708 193.644 107.906",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.325 117.663C188.066 117.959 188.986 117.236 189.293 116.992C190.323 116.172 191.338 115.355 192.397 114.57C193.807 113.526 195.184 112.346 196.523 111.212C197.477 110.404 198.349 109.467 199.35 108.718C199.731 108.432 200.08 108.118 200.475 107.85C200.731 107.677 201.264 107.364 201.355 107.091",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.486 125.09C188.418 125.09 188.53 125.043 188.552 125.024C189.068 124.603 189.595 124.197 190.115 123.783C191.062 123.028 192.014 122.281 192.974 121.542C194.46 120.398 195.911 119.207 197.39 118.054C198.112 117.492 198.83 116.935 199.538 116.356C200.164 115.843 200.685 115.208 201.311 114.693C202.241 113.929 203.187 113.167 203.959 112.241",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.356 131.704C189.457 131.692 189.558 131.597 189.633 131.535C190.157 131.107 190.732 130.73 191.298 130.36C192.325 129.689 193.33 128.99 194.363 128.33C196.192 127.161 197.905 125.928 199.575 124.535C200.715 123.585 201.769 122.553 202.953 121.65C203.642 121.124 204.807 120.59 205.263 119.831",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.921 139.563C190.461 138.026 192.073 136.495 193.808 135.175C195.64 133.781 197.609 132.566 199.454 131.184C200.79 130.184 202.156 129.23 203.363 128.073C203.847 127.609 204.362 127.188 204.883 126.769C205.211 126.506 205.726 126.142 205.861 125.739",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M180.886 122.433C180.886 122.434 183.326 120.481 183.818 120.481",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.406 126.987C182.839 126.555 183.422 126.295 183.926 125.957C184.287 125.716 184.656 125.281 185.066 125.144",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.732 133.332C183.278 133.332 184.009 132.536 184.4 132.226C185.086 131.683 185.72 131.216 186.478 130.784",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.817 139.836C184.06 139.617 184.427 139.488 184.698 139.306C185.255 138.93 185.762 138.552 186.369 138.264",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.547 148.676C183.482 148.734 183.404 148.718 183.475 148.622C183.803 148.177 184.349 147.814 184.79 147.501C186.34 146.401 187.971 145.371 189.58 144.357C192.63 142.433 195.74 140.564 198.71 138.517C199.522 137.957 200.288 137.331 201.12 136.8C201.869 136.321 202.663 135.838 203.337 135.255C204.063 134.627 206.558 133.175 205.698 133.604",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M190.496 149.486C190.288 149.456 190.809 149.206 190.979 149.082C192.157 148.226 193.267 147.286 194.471 146.462C196.196 145.282 197.821 143.968 199.539 142.775C201.03 141.74 202.487 140.631 203.955 139.559C204.139 139.424 205.721 138.542 205.535 138.264",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M207.761 124.656C208.002 124.285 208.465 124.006 208.798 123.728C209.298 123.312 209.787 122.883 210.288 122.469C210.832 122.021 211.377 121.555 211.941 121.132",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M207.326 132.302C207.129 132.049 210.909 129.331 211.325 128.959C212.306 128.084 213.232 127.148 214.221 126.284",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M207.924 138.049C207.767 138.132 207.762 138.191 207.939 138.061C209.256 137.094 210.496 135.981 211.745 134.929C212.764 134.071 213.822 133.244 214.765 132.302",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.282 142.818C209.516 142.373 209.974 142.055 210.346 141.739C211.474 140.784 212.688 139.938 213.824 138.992C214.949 138.056 216.112 137.125 217.1 136.041",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M212.648 145.746C212.669 145.809 212.949 145.499 212.967 145.481C213.889 144.594 214.912 143.816 215.917 143.029C216.764 142.366 217.604 141.693 218.415 140.987C218.584 140.839 218.882 140.624 218.946 140.433",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.588 147.104C217.613 147.012 217.696 146.937 217.763 146.875C218.312 146.361 218.956 145.939 219.552 145.483C220.213 144.978 220.939 144.269 221.714 143.959",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.876 148.187C222.318 147.769 222.866 147.151 223.397 146.886",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M151.495 69.0887C151.236 69.0887 151.393 69.0861 151.582 69.0495C152.147 68.9395 153.24 68.4789 153.754 68.7357",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.271 64.2961C151.938 64.2961 153.178 64.4777 153.259 64.1549",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.624 59.9965C152.378 59.9965 153.143 60.0484 153.329 60.2082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M151.847 72.6119C151.358 72.6819 152.835 72.6825 153.33 72.6825",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M151.671 77.4403C151.489 77.2359 153.202 77.3736 153.435 77.4403",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M151.882 81.459C151.34 81.459 152.965 81.5656 153.505 81.5296",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.235 86.2516C152.032 86.2516 151.972 86.332 152.22 86.3771C152.583 86.4432 153.052 86.3009 153.435 86.3222",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.189 52.4174C156.189 50.7579 156.105 48.963 156.75 47.3934C157.22 46.2484 157.779 45.1514 158.381 44.061C158.926 43.0743 159.815 42.2371 160.565 41.406C161.026 40.8956 162.113 39.8011 162.895 39.9963C163.651 40.185 164.397 40.3227 165.044 40.7873C165.755 41.2987 166.418 41.8601 167.13 42.3732C167.782 42.8438 168.38 42.8943 168.4 43.8025C168.422 44.7537 168.466 45.9211 168.173 46.8334C167.766 48.1023 167.473 49.4039 166.989 50.6475C166.597 51.6525 166.028 52.6394 165.479 53.5687C164.951 54.4631 164.346 54.9274 163.444 55.4483C162.872 55.7781 161.955 56.4861 161.271 56.5056C160.866 56.5172 160.262 56.4289 159.891 56.2942C159.377 56.1075 158.985 55.5155 158.444 55.2721C157.858 55.009 157.408 54.3838 157.106 53.8272C156.917 53.477 156.64 53.1752 156.471 52.809C156.225 52.2768 156.605 51.2734 156.683 50.7258",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M156.965 34.5124C156.61 34.4915 156.848 34.6492 157.083 34.7947C157.904 35.3044 159.238 35.1616 160.142 34.9359",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M159.718 31.1309C159.54 30.9726 159.43 31.1533 159.691 31.2329C160.455 31.4653 161.48 31.2088 162.259 31.1309",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.966 27.816C162.862 27.9067 162.84 27.5566 162.824 27.4714C162.697 26.7847 162.824 26.0454 162.824 25.349",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M164.659 22.5317C164.563 22.5317 164.309 22.5283 164.487 22.6416C165.103 23.034 166.047 22.7122 166.706 22.6023",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.071 20.1344C166.115 19.6908 166.323 19.273 166.353 18.7952",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.944 178.494C146.944 177.248 147.426 175.983 147.75 174.798C148.281 172.855 148.712 171.012 149.531 169.162C151.039 165.757 152.535 162.467 154.768 159.467C156.469 157.18 157.925 154.51 160.208 152.718C160.545 152.454 162.956 150.38 162.97 150.394",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M190.353 152.664C190.353 152.001 190.96 152.674 191.201 152.874C192.179 153.683 193.1 154.454 193.915 155.436C194.655 156.33 195.128 157.352 195.653 158.376C196.16 159.366 196.927 160.183 197.539 161.1C199.373 163.846 200.773 167.37 201.304 170.655C201.701 173.115 201.74 175.857 202.404 178.244C202.609 178.98 202.39 179.882 202.657 180.575C202.758 180.838 203.038 182.364 202.594 181.772",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M147.322 181.013C150.144 181.013 152.996 181.517 155.847 181.517C159.912 181.517 164.152 181.235 168.192 181.713C171.756 182.136 175.257 182.526 178.855 182.526C180.431 182.526 181.994 182.342 183.573 182.407C184.907 182.461 186.206 182.652 187.548 182.652C191.393 182.652 195.213 182.4 199.06 182.4C200.091 182.4 201.151 182.526 202.158 182.526C202.631 182.526 203.944 182.543 202.593 182.274",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.071 180.509C146.568 180.437 147.071 177.308 147.071 176.855",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M160.952 158.206C161.697 156.718 163.478 155.348 164.751 154.314C166.183 153.152 167.527 151.784 169.154 150.898",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.854 161.611C166.505 158.963 169.575 156.602 172.372 154.099C173.204 153.355 174.078 152.66 174.973 151.992C175.157 151.854 176.012 151.417 175.463 151.782",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M168.396 164.761C168.459 164.475 169.011 164.035 169.202 163.844C170.982 162.067 172.988 160.543 174.845 158.853C176.725 157.142 178.626 155.446 180.608 153.854C181.39 153.226 182.231 152.717 183.034 152.132C183.47 151.814 184.464 151.193 184.674 150.774",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.065 167.281C172.654 167.742 174.481 166.118 174.523 166.077C177.531 163.088 180.609 160.303 183.791 157.501C185.931 155.617 187.884 153.426 190.1 151.656",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175.083 172.698C171.39 175.925 182.071 165.815 185.557 162.366C188.319 159.633 191.224 157.255 193.759 154.301",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M179.249 177.109C179.401 177.076 179.479 176.933 179.586 176.829C180.517 175.916 181.48 175.034 182.418 174.127C184.269 172.336 185.989 170.417 187.851 168.639C190.079 166.511 192.291 164.354 194.266 161.988",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M193.76 162.743C194.831 161.674 196.045 160.737 197.167 159.719",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 179.754C180.214 184.273 194.543 169.733 199.565 165.137",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M189.217 181.644C189.217 181.765 189.945 180.87 190.016 180.789C191.678 178.911 193.648 177.32 195.463 175.595C196.708 174.413 197.981 173.246 199.158 171.997C199.439 171.698 200.626 170.203 201.079 170.429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.536 176.855C197.325 176.953 197.252 180.007 197.174 180.628C197.121 181.058 197.167 182.694 197.167 182.399",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M196.788 177.487C196.661 178.497 201.095 179.785 202.088 179.125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M163.096 176.734C162.269 175.907 162.578 177.491 163.047 177.903C164.089 178.817 165.66 175.992 163.727 175.992C162.708 175.992 161.814 177.843 162.844 178.372C164.083 179.008 164.176 177.297 163.601 176.608",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M175.085 176.857C174.526 175.803 173.87 177.508 174.096 178.131C174.554 179.389 175.885 178.348 176.207 177.613C176.556 176.816 175.542 175.7 174.832 176.409C174.328 176.912 174.074 178.022 174.959 178.243",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M153.38 176.604C153.38 176.139 153.247 176.935 153.324 177.164C153.658 178.165 154.689 177.108 154.557 176.359C154.255 174.633 152.085 177.061 153.884 177.36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M164.484 183.598C164.484 181.99 163.078 186.51 162.64 188.057C162.156 189.767 161.474 191.342 161.231 193.118C160.831 196.035 160.08 198.913 160.6 201.897C160.842 203.289 160.68 204.741 160.887 206.146C161.171 208.076 161.365 209.995 161.834 211.894C162.494 214.566 164.025 217.173 165.241 219.636C166.396 221.978 167.486 224.314 168.872 226.539C169.88 228.155 170.805 229.788 171.676 231.481C172.287 232.667 172.825 233.831 173.415 235.009C173.675 235.529 173.964 236.039 174.2 236.57C174.784 237.882 174.071 235.709 173.822 235.261",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M189.47 185.237C189.676 186.879 190.626 188.53 190.956 190.18C191.26 191.695 191.363 193.425 191.363 194.968C191.363 198.098 191.467 201.519 190.676 204.566C190.284 206.076 190.156 207.627 189.659 209.116C189.282 210.247 188.74 211.271 188.334 212.385C187.419 214.899 186.299 217.176 184.927 219.483C183.653 221.627 182.307 223.704 181.043 225.84C180.09 227.451 179 228.955 178.239 230.663C177.869 231.495 177.277 232.22 176.914 233.064C176.696 233.573 176.499 234.266 176.164 234.695C175.924 235.003 175.788 235.489 175.589 235.837C175.324 236.299 175.498 236.936 174.958 236.397",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 185.488C190.1 184.722 189.474 184.172 189.09 183.598",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M172.057 186.748C171.636 187.121 173.084 186.29 173.585 186.034C175.71 184.948 177.786 183.839 180.007 182.968",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M173.57 190.654C173.867 190.624 174.125 190.407 174.384 190.276C176.192 189.363 178.003 188.448 179.838 187.588C182.46 186.359 185.09 185.088 187.577 183.598",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M175.842 194.812C176.572 194.739 177.544 194.005 178.085 193.706C180.253 192.504 182.423 191.297 184.549 190.023",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M178.617 197.961C178.22 198.358 178.377 198.176 178.834 197.94C180.536 197.063 182.337 196.419 184.043 195.567",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M179.627 203.631C179.562 203.631 180.675 202.995 180.791 202.931C181.799 202.374 182.79 201.613 183.918 201.363",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M181.645 206.656C181.598 206.656 183.521 206.224 184.169 206.278",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M181.015 211.319C181.691 210.559 182.962 210.94 183.917 210.94",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M181.015 215.479C181.054 215.795 182.197 215.837 182.403 215.857",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M154.136 183.094C151.887 187.586 150.238 192.525 150.098 197.599C149.978 201.97 149.761 206.804 150.666 211.124C150.997 212.704 151.514 214.239 151.767 215.828C152.022 217.436 153.135 218.759 153.505 220.329C153.848 221.785 154.656 223.191 155.146 224.607C155.632 226.013 156.104 227.423 156.688 228.793C157.893 231.615 158.785 234.501 160.6 237.025C162.118 239.136 163.324 241.663 165.178 243.515C166.201 244.536 167.286 245.8 168.207 246.924C168.551 247.345 170.035 249.626 169.784 249.626",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M200.449 183.849C200.372 183.86 201.135 187.02 201.178 187.224C201.422 188.378 201.585 189.628 201.585 190.808C201.585 193.039 201.711 195.234 201.711 197.458C201.711 201.776 201.455 206.091 200.673 210.339C199.941 214.32 199.081 218.16 197.897 222.03C197.644 222.856 197.137 223.632 196.663 224.354C196.097 225.219 195.707 226.353 194.995 227.098C194.09 228.045 193.485 229.805 193.004 231.004C191.951 233.633 189.72 235.76 188.307 238.187C187.042 240.359 185.356 242.208 183.568 243.927C182.465 244.987 181.551 246.485 180.862 247.862C180.009 249.565 179.628 251.516 179.628 253.406",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M169.343 249.564C170.951 249.564 171.74 254.937 171.74 256.144C171.74 257.96 171.993 259.791 171.993 261.633C171.993 263.612 172.119 265.596 172.119 267.583C172.119 271.302 172.75 275.036 172.75 278.77C172.75 280.532 172.538 282.675 172.904 284.412C173.082 285.255 173.002 286.154 173.002 287.016C173.002 287.566 173.005 288.632 172.624 287.618",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M172.876 285.601V355.283",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.438 253.216V358.307",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M156.093 184.796C155.866 184.861 156.425 185.462 156.5 185.524C156.993 185.937 157.676 185.586 158.112 185.804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M154.578 190.087C154.477 190.087 154.844 189.812 155.083 189.897C155.657 190.102 156.248 190.087 156.85 190.087",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M154.327 194.121C154.327 193.994 154.642 194.194 154.762 194.22C155.3 194.336 155.924 194.248 156.472 194.248",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M153.316 197.901C154.279 197.901 155.279 197.667 156.218 197.901",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 201.553C153.399 201.553 155.422 201.352 156.093 201.426",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M154.325 205.209C153.735 205.209 155.507 205.258 156.092 205.336",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M154.705 209.998C154.801 209.233 155.965 209.942 156.219 210.124",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M154.957 214.031C154.396 214.031 156.05 213.778 156.597 213.652",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M141.455 174.965C141.455 172.232 141.994 180.428 141.833 183.156",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M137.795 179.502C137.376 179.595 137.455 180.725 137.445 180.958C137.346 183.203 137.267 185.448 137.165 187.692",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M206.316 169.422C206.015 169.384 206.904 171.025 207.017 171.27C208.002 173.409 208.935 175.569 209.849 177.739",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M214.013 170.053C213.433 169.781 213.631 170.62 213.648 170.999C213.752 173.246 213.915 175.491 214.013 177.74",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.218 218.44C155.402 218.44 157.809 218.059 158.616 217.935",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M157.354 223.734C157.539 223.178 158.97 223.253 159.373 223.229",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M158.995 228.519C158.936 228.511 160.848 227.367 161.141 227.259",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M161.14 232.424C160.722 232.372 162.435 231.813 162.655 231.793",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M163.412 235.325C163.743 235.027 164.126 234.736 164.548 234.946",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M167.323 239.106C166.457 239.106 168.085 237.817 168.333 237.594",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M179.564 242.884C179.394 242.905 179.363 243.348 179.515 243.382C179.929 243.474 180.372 243.382 180.7 243.136",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M181.582 239.484C181.539 239.484 182.191 239.284 182.339 239.358",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M185.117 233.937C184.765 234.874 185.343 234.34 185.874 234.693",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M187.64 230.537C188.112 230.589 188.299 230.696 188.776 230.41",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M189.785 227.387C189.573 227.629 190.683 227.349 190.794 227.387",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M191.047 224.109C190.535 224.109 192.054 223.929 192.561 223.857",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M192.436 220.33C192.095 220.373 192.342 220.571 192.506 220.646C193.003 220.872 193.619 220.535 193.95 220.204",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M194.077 216.044C194.04 216.342 194.921 215.845 195.213 215.917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M194.833 209.998C194.66 210.019 195.801 209.913 196.095 209.871",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.337 205.336C195.139 205.163 195.487 205.372 195.667 205.392C196.23 205.455 196.702 205.166 197.104 204.831",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M195.59 199.915C195.662 200.487 197.389 199.584 197.483 199.537",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M197.357 195.507C197.195 195.363 196.648 195.282 197.077 195.409C197.435 195.515 197.849 195.242 198.114 195.507",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M195.464 191.223C195.265 191.246 196.416 190.941 196.852 190.592",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M195.085 187.063C194.98 186.789 194.174 186.443 194.468 186.432C195.105 186.409 195.536 186.239 196.095 186.558",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M128.583 156.381C128.632 156.818 129.097 156.892 129.355 157.172C130.11 157.995 130.076 158.618 130.252 159.63C130.66 161.971 130.445 164.476 130.666 166.854C130.897 169.351 130.729 171.887 130.729 174.394C130.729 176.56 130.981 178.722 130.981 180.897C130.981 183.875 130.981 186.855 130.981 189.836C130.981 191.567 131.233 193.269 131.233 194.968C131.233 198.116 131.486 201.228 131.486 204.383C131.486 205.249 131.672 206.209 131.549 207.044C131.461 207.639 131.505 208.231 131.486 208.829C131.439 210.331 130.981 211.787 130.981 213.295C130.981 214.741 130.891 216.333 131.205 217.747C131.517 219.149 130.916 220.764 131.24 222.221C131.396 222.919 131.23 223.721 131.107 224.44C130.972 225.232 131.107 226.116 131.107 226.925C131.107 227.319 131.107 227.714 131.107 228.108C131.107 229.15 131.017 227.469 130.981 227.198",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M130.98 227.699C131.122 227.54 131.015 227.4 130.987 227.524C130.861 228.091 131.003 228.832 131.044 229.393C131.159 230.978 131.029 232.524 130.98 234.097C130.913 236.271 130.728 238.449 130.728 240.622C130.728 242.199 130.806 243.479 131.135 244.99C131.374 246.09 131.889 247.018 131.864 248.14C131.786 251.623 131.611 255.15 131.611 258.627C131.611 259.664 131.434 260.703 131.485 261.721C131.524 262.487 131.864 264.756 131.864 263.989",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M131.864 265.061C131.864 263.116 132.748 268.884 132.748 270.829C132.748 273.359 132.748 275.888 132.748 278.418C132.748 280.507 133.252 282.521 133.252 284.592C133.252 285.027 133.388 287.63 133.126 287.238",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3004 292.407C84.4997 292.407 84.1483 293.742 84.0595 294.318C83.8656 295.577 84.4464 296.928 85.3845 297.755C86.3634 298.618 87.4199 298.851 88.6444 299.148C89.2257 299.289 90.5965 299.782 91.1612 299.519C91.964 299.145 92.7503 298.497 93.5588 298.203C94.0208 298.035 95.2823 296.443 94.5122 296.187",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8896 296.94C94.8896 300.674 98.7222 301.488 101.55 299.894C102.701 299.245 103.491 298.266 103.471 296.912C103.456 295.961 103.173 294.679 102.209 294.294",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M102.967 295.179C102.556 295.23 103.834 296.539 103.921 296.607C104.849 297.328 106.083 297.359 107.195 297.195C108.888 296.944 111.11 295.187 112.046 293.786C113.757 291.222 113.782 286.779 112.305 284.146C111.106 282.008 108.449 280.058 105.989 279.813C104.447 279.659 102.72 279.756 101.208 280.058C100.327 280.234 99.71 280.921 98.9291 281.311C98.4815 281.534 98.5577 281.545 98.3963 281.094C98.1673 280.453 97.8169 280.062 97.2887 279.652C96.2915 278.877 95.3399 278.672 94.0358 278.672C91.4356 278.672 89.2542 279.722 87.0953 281.094C84.2489 282.903 82.137 285.025 82.8049 288.626C83.024 289.808 83.7063 291.097 84.6697 291.804C84.9805 292.033 85.5113 292.392 85.9036 292.407C86.3369 292.423 86.4687 292.122 86.0578 292.533",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9791 292.405C90.1733 292.405 90.4227 292.266 90.9441 291.537C91.7138 290.461 92.4403 289.246 93.2926 288.24C93.3758 288.142 93.1692 288.765 93.1244 288.877",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M96.91 291.521C96.2761 291.521 97.6082 289.937 97.7092 289.771C98.3665 288.69 98.9279 287.526 99.6862 286.509C99.9679 286.131 99.6785 286.459 99.56 286.607",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M101.327 290.895C100.674 290.968 102.307 289.114 102.463 288.893C103.135 287.941 103.924 287.007 104.482 285.981C104.602 285.759 104.602 285.801 104.482 285.981",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M106.879 291.902C106.396 291.36 109.181 287.996 107.636 288.878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M220.496 240.51C220.496 245.226 221.646 250.719 220.496 255.314C219.303 260.081 220.281 264.789 220.281 269.665C220.281 276.745 222.02 297.914 221.14 290.889",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M227.366 160.013C227.366 167.014 228.13 174.276 226.77 181.07C226.333 183.248 226.515 184.903 226.829 187.036C227.259 189.953 226.722 192.911 226.722 195.814C226.722 202.76 225.758 209.85 226.245 216.776C226.534 220.891 226.507 225.117 226.507 229.245C226.507 230.357 226.507 231.468 226.507 232.58C226.507 235.13 225.685 231.616 225.434 230.758",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M225.649 233.758C226.576 232.935 226.577 232.544 226.293 233.961C225.652 237.163 225.649 240.865 225.649 244.156C225.649 246.347 225.27 248.398 224.957 250.551C224.599 253.016 225.005 255.831 225.005 258.364C225.005 260.869 225.22 263.317 225.22 265.82C225.22 268.522 224.985 271.315 224.802 273.966C224.656 276.083 223.982 279.007 224.623 281.088C224.969 282.21 225.934 284.593 224.576 282.422",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3224 344.06C60.5356 345.975 64.6215 345.554 65.7895 345.749C68.0947 346.132 69.9778 347.115 72.0118 348.071C72.6393 348.366 71.3554 346.851 71.0452 346.231C70.1693 344.482 69.4634 342.765 69.7011 340.772C70.0829 337.57 69.8525 333.781 72.5555 331.573C75.0677 329.52 77.6501 326.648 80.9827 326.083C86.0858 325.218 91.5415 326.743 95.6623 329.944C96.4552 330.56 100.435 332.968 100.435 334.016C100.435 336.465 98.3227 329.254 98.8036 326.852C100.039 320.684 105.304 313.114 112.305 313.114C114.236 313.114 116.161 312.715 118.09 312.857C119.776 312.982 121.38 313.607 123.119 313.657C125.001 313.71 128.654 314.797 130.051 316.085C132.003 317.885 133.233 319.346 134.823 321.529C136.746 324.169 137.218 327.744 138.07 330.849C138.738 333.281 138.05 336.275 137.813 338.751C137.766 339.252 137.275 343.577 136.711 341.888",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M138.072 340.801C137.791 341.081 139.176 340.72 139.476 340.65C141.925 340.08 144.267 339.107 146.741 338.629C149.33 338.13 152.013 338.899 154.383 339.987C158.17 341.724 159.846 344.832 160.695 348.884C160.98 350.24 160.67 351.993 160.152 353.288C159.356 355.274 162.627 352.715 163.353 352.534C165.465 352.007 167.602 352.806 169.545 353.499C170.175 353.723 171.556 354.383 170.15 354.102",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M182.382 356.815C181.089 358.268 185.029 354.498 185.403 354.251C188.324 352.321 190.938 352.324 194.283 352.2C194.819 352.18 193.651 347.398 193.588 346.831C193.062 342.106 191.45 337.875 191.64 333.047C191.924 325.819 195.144 318.571 202.166 315.674C205.557 314.276 210.111 315.645 212.149 318.811C213.41 320.77 212.829 319.05 212.829 317.273C212.829 313.431 212.347 309.822 215.306 306.867C217.152 305.023 224.526 299.316 227.508 301.981C230.87 304.985 229.995 309.852 229.411 313.789C229.255 314.846 228.602 316.394 229.139 317.333C229.749 318.398 230.673 318.301 229.139 318.811",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M231.857 317.183C231.117 317.276 230.628 318.348 232.567 317.59C234.737 316.742 240.498 317.442 242.187 319.37C245.487 323.136 243.296 326.426 241.432 329.942C240.659 331.399 239.814 331.332 241.794 330.62C244.277 329.728 246.709 331.027 249.255 331.027C253.126 331.027 253.891 339.319 253.469 341.765C253.162 343.543 251.581 346.558 254.42 345.686C256.402 345.077 258.523 344.029 260.612 344.268C264.658 344.732 270.727 346.797 273.056 350.451C274.808 353.2 272.297 347.132 272.15 346.38C270.896 339.93 272.084 333.633 273.993 327.438C275.524 322.468 277.289 317.224 279.762 312.629C282.051 308.376 285.094 305.556 288.461 302.193C293.519 297.143 300.989 292.316 308.381 294.23C312.922 295.406 318.799 296.071 321.898 300.082C324.56 303.528 325.915 307.497 325.915 311.89C325.915 313.24 325.643 317.282 325.643 315.932C325.643 313.972 326.214 314.092 328.211 313.534C332.527 312.327 337.412 312.709 340.263 316.369C343.907 321.048 341.405 329.472 339.236 334.285C335.849 341.8 331.138 347.529 325.976 353.83C324.422 355.726 323.399 357.818 322.11 359.862C321.329 361.099 320.75 364.513 320.75 361.159",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M321.43 361.703C322.232 361.525 323.348 360.084 324.027 359.621C325.505 358.615 326.913 357.802 328.679 357.57C330.759 357.297 331.892 357.14 333.935 357.691C337.34 358.61 339.444 362.832 339.372 366.106C339.318 368.515 337.646 370.897 336.925 373.164C336.763 373.674 334.342 378.548 334.478 378.684C334.981 379.185 335.554 377.742 336.17 377.387C337.098 376.851 338.042 376.777 339.039 377.175C341.018 377.966 343.127 379.468 343.993 381.458C345.721 385.428 344.437 389.756 343.389 393.734C343.104 394.815 342.634 395.783 342.634 396.931C342.634 397.67 344.345 396.716 345.292 396.931C347.098 397.341 348.384 399.527 349.974 400.46C351.355 401.271 350.949 401.518 351.272 399.224C351.684 396.297 352.169 392.658 354.323 390.477C356.381 388.393 359.062 386.783 361.663 385.485C364.885 383.876 367.529 387.06 369.124 389.376C371.909 393.422 373.087 398.253 371.585 403.084C371.34 403.873 369.92 407.635 370.377 407.141C371.965 405.424 372.826 403.929 375.285 403.371C379.488 402.417 381.845 403.28 385.027 405.663C389.272 408.843 388.114 412.581 387.216 417.064C386.729 419.496 387.32 417.916 388.304 416.793C389.632 415.277 390.933 413.719 393.212 414.516C396.722 415.742 399.702 415.234 402.681 417.879C405.24 420.149 409.327 427.303 406.246 430.381",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M358.13 369.033C356.709 366.353 356.345 365.013 357.495 361.825C358.739 358.376 359.531 355.452 363.159 353.862C365.132 352.997 366.361 353.466 368.248 354.164C370.081 354.841 369.001 355.168 369.683 353.123C371.077 348.949 375.409 342.921 380.149 342.22C382.116 341.929 384.734 344.105 385.435 345.824C386.436 348.277 385.458 350.417 384.227 352.535C383.344 354.054 381.707 355.636 384.076 354.103C386.672 352.423 389.751 352.846 392.095 354.797C394.02 356.398 395.295 359.452 395.373 361.915C395.447 364.305 395.398 364.512 394.164 366.304C393.878 366.719 392.5 366.993 393.062 367.118C394.079 367.344 395.722 367.166 396.4 368.068C398.729 371.169 398.618 376.609 395.373 379.017C394.801 379.441 392.93 379.541 393.258 380.646C393.699 382.132 394.799 383.72 394.799 385.336C394.799 389.331 392.323 391.581 388.576 390.75C385.973 390.172 382.692 386.38 381.78 384.024C380.872 381.676 381.209 378.149 382.596 376.031C383.554 374.567 382.085 375.316 380.965 375.488C379.014 375.788 376.837 375.614 375.014 374.87C372.589 373.879 370.226 372.657 369.139 370.27C368.749 369.411 368.23 369.905 367.644 370.406C366.08 371.745 364.078 371.54 362.207 370.873C358.487 369.546 356.877 367.29 355.411 363.876",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M367.916 364.146C367.44 364.146 366.146 364.618 366.768 364.085C367.781 363.219 369.068 361.974 370.363 361.974",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M371.451 366.861C373.95 366.584 375.502 363.135 377.975 362.518",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M376.343 369.845C376.068 369.806 378.916 367.582 379.062 367.463C381.591 365.39 384.229 363.328 386.401 360.887",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M382.051 370.388C381.516 370.495 380.716 371.614 381.538 370.886C383.155 369.45 384.792 368.034 386.401 366.588",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M385.042 373.917C385.059 374.042 388.796 370.922 389.119 370.66",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M388.576 378.534C389.628 378.324 390.471 376.578 391.023 375.819",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9436 382.966C60.9411 382.946 64.6299 386.464 64.4994 386.073",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8331 386.296C64.7528 386.161 66.987 383.689 67.043 383.633C69.2138 381.448 71.6224 379.228 74.5498 378.085C76.812 377.201 80.0021 377.343 81.7232 379.194C83.8635 381.496 84.7127 383.847 84.0444 386.851C84.0011 387.045 83.6308 387.788 83.7357 387.714C84.648 387.063 85.1479 386.194 86.3903 386.086C88.7085 385.885 89.6806 386.694 91.6623 387.455C93.7787 388.267 93.8889 393.566 92.5019 394.951",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1687 395.616C93.9055 395.774 96.7054 394.968 97.0207 394.901C99.2262 394.431 100.25 394.528 101.947 395.961C104.085 397.768 103.07 399.838 102.947 402.052C102.869 403.457 103.794 401.653 104.725 401.214C106.29 400.475 108.258 401.036 109.837 401.386C110.995 401.643 114.059 404.02 114.059 405.381",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M114.726 406.491C113.735 405.392 114.178 402.683 114.331 401.387C114.617 398.96 115.62 396.05 116.726 393.842C118.58 390.139 120.841 388.113 124.504 386.284C129.413 383.833 135.897 382.735 141.222 384.743C145.676 386.423 150.233 389.136 149.284 394.631C148.784 397.529 148.666 400.711 147.123 403.335C146.037 405.184 144.288 407.746 142.506 408.932",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M143.616 408.268C146.87 404.657 154.79 404.858 156.95 409.71C157.61 411.192 158.249 412.191 157.889 413.989C157.645 415.204 157.434 416.273 156.95 417.416C156.558 418.343 155.653 419.531 155.716 420.597C155.724 420.746 157.789 419.891 157.938 419.808C159.064 419.178 160.265 418.821 161.531 418.587C164.592 418.021 166.191 417.772 168.507 419.919C170.069 421.367 170.773 423.067 171.618 424.912C171.868 425.457 171.917 425.953 172.334 426.416C172.717 426.841 172.43 425.944 172.285 425.8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M173.843 426.462C173.983 426.955 176.47 424.71 176.509 424.675C178.105 423.226 179.892 421.735 182.065 421.309C184.512 420.829 187.381 420.204 189.622 421.753C191.368 422.96 192.546 424.467 193.523 426.364C194.246 427.766 193.351 427.28 194.338 426.339C197.233 423.579 202.709 422.802 204.277 427.239C204.781 428.664 205.076 430.607 204.944 432.121C204.883 432.819 204.289 436.733 204.289 434.451",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M158.952 406.937C158.323 407.496 157.689 406.667 157.964 406.037C159.028 403.61 162.513 400.134 165.397 400.058C166.72 400.023 170.702 400.224 171.57 401.611C171.716 401.843 170.56 402.481 170.509 401.611C170.411 399.962 169.506 398.835 169.225 397.222C168.837 394.996 169.397 392.553 169.397 390.306C169.397 388.14 169.867 386.462 170.953 384.573C172.463 381.946 174.566 379.461 177.447 378.31C180.229 377.199 183.333 377.365 185.621 379.247C186.453 379.931 186.894 380.942 187.522 381.749C188.048 382.424 188.227 382.319 187.399 382.526",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M187.621 380.749C187.815 379.006 187.772 377.082 188.386 375.398C189.426 372.55 191.406 370.392 193.189 367.988C195.279 365.171 198.805 364.103 202.116 365.165C204.763 366.015 207.216 367.613 208.622 370.109C209.175 371.09 211.631 376.528 210.289 377.198",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M211.399 377.419C211.774 374.049 221.095 375.922 222.956 376.852C225.923 378.333 227.845 382.474 227.845 385.741C227.845 386.55 227.433 388.992 228.561 388.022C230.145 386.658 232.194 386.517 234.117 386.517C236.306 386.517 238.781 386.733 239.896 388.737C240.152 389.198 241.234 392.093 240.735 391.844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M241.402 390.515C241.635 390.777 241.468 391.516 241.735 390.823C242.245 389.5 241.612 387.72 241.76 386.36C242.11 383.142 243.284 380.098 244.563 377.15C246.539 372.597 250.159 366.753 255.304 365.315C257.507 364.699 259.812 363.609 262.12 364.378C263.349 364.787 264.694 365.429 265.849 366.005C269.006 367.581 266.996 374.148 266.466 376.583C265.976 378.833 265.193 381.758 264.071 383.759C263.462 384.845 262.948 386.065 262.07 386.964C261.345 387.708 260.189 388.481 259.675 389.405C259.164 390.324 258.812 390.798 260.07 390.17C261.781 389.316 263.312 389.405 265.083 389.405C267.565 389.405 268.632 389.866 269.972 391.97C271.63 394.571 271.078 400.828 268.96 402.942",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M270.738 402.72C269.835 402.821 271.224 402.947 271.455 402.942C273.863 402.89 276.103 401.801 278.542 401.833C281.664 401.873 283.353 403.292 285.851 404.816C289.948 407.316 289.228 412.083 286.851 415.37C285.952 416.613 286.343 416.163 287.394 415.481C288.232 414.936 288.725 414.482 289.752 414.482C291.38 414.482 292.968 414.896 293.802 416.479C295.223 419.175 292.962 428.624 292.962 425.578",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M294.295 426.241C294.011 426.2 297.682 423.33 298.049 423.159C299.744 422.365 301.49 422.468 303.308 422.468C305.638 422.468 306.383 423.794 307.012 425.748C307.248 426.479 307.436 427.061 307.407 427.844C307.371 428.827 307.26 428.545 308.185 427.905C310.195 426.516 312.038 428.625 314.025 429.077C315.5 429.411 316.697 430.635 317.742 431.678C318.83 432.764 319.554 431.755 320.742 432.282C324.252 433.84 327.62 435.903 328.076 440",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M293.184 324.159C292.712 324.159 292.271 324.521 292.665 324.233C294.67 322.765 297.259 320.705 298.518 318.611",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M291.629 338.364C292.653 336.422 294.346 334.88 295.765 333.235C297.98 330.668 300.108 328.004 302.21 325.345C303.857 323.262 305.411 321.083 307.186 319.106C308.124 318.062 309.224 316.984 309.853 315.728",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M266.516 377.863C272.506 371.283 277.764 363.965 283.258 356.978C287.172 352 292.017 347.702 295.296 342.245C297.661 338.309 300.938 335.096 303.408 331.26C304.542 329.498 305.712 327.838 306.964 326.155C308.209 324.482 310.313 322.557 310.964 320.607",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M268.071 385.185C267.55 385.95 266.16 388.631 267.626 386.516C270.167 382.851 272.847 379.144 275.973 375.963C279.768 372.099 282.337 367.314 286.023 363.313C288.877 360.215 291.349 356.737 293.838 353.339C295.795 350.669 297.962 348.235 300.308 345.893C302.885 343.32 305.005 340.259 307.197 337.361C309.279 334.609 311.232 331.768 313.618 329.261C314.122 328.731 319.077 323.547 318.075 323.047",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M270.515 392.066C265.948 397.197 279.485 381.652 283.677 376.211C286.671 372.324 290.264 368.677 293.554 365.017C296.059 362.231 298.816 359.568 301.172 356.658C305.572 351.224 309.961 345.504 313.84 339.693C315.423 337.322 317.067 335.152 319.087 333.134C320.579 331.645 321.991 330.069 323.396 328.498C323.698 328.161 326.243 325.629 325.186 326.156",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M273.183 400.276C273.183 398.169 276.685 395.566 277.85 394.186C281.675 389.655 285.624 385.195 289.394 380.624C294.974 373.859 300.739 367.283 306.507 360.676C310.873 355.675 316.068 351.168 320.076 345.906C321.972 343.417 323.879 340.974 326.249 338.903C327.405 337.894 328.388 336.707 329.583 335.747C330.074 335.352 331.456 334.597 330.299 334.366",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M281.628 400.501C281.561 400.835 280.708 401.514 280.788 401.389C281.138 400.849 281.843 400.407 282.27 399.91C286.392 395.114 290.344 390.128 294.098 385.041C297.187 380.856 301.051 377.374 304.173 373.218C307.818 368.364 311.778 363.738 316.075 359.446",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M285.627 406.272C292.091 400.355 298.274 394.037 304.061 387.433C306.929 384.16 309.219 380.273 312.296 377.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M292.296 412.929C295.014 407.771 299.833 403.55 303.482 399.059C306.879 394.878 310.02 390.426 313.803 386.57C315.913 384.419 317.165 381.66 319.285 379.542C319.993 378.835 322.117 376.715 321.409 377.422",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M296.74 417.81C297.402 416.127 298.899 414.59 300.148 413.298C301.924 411.461 303.408 409.362 305.136 407.478C309.112 403.144 313.439 399.147 317.199 394.619C319.398 391.971 321.404 388.929 323.743 386.42C324.682 385.413 325.513 384.34 326.397 383.289C326.743 382.878 328.291 381.196 327.187 381.637",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M302.295 422.471C302.306 422.533 303.54 421.114 303.666 420.966C305.626 418.664 307.649 416.498 309.852 414.432C313.024 411.457 316.076 408.076 318.531 404.47C319.927 402.421 321.594 400.668 323.063 398.713C323.545 398.07 325.289 395.533 325.186 395.84",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M307.406 427.795C302.905 431.728 315.019 418.582 318.839 413.986C320.444 412.056 321.883 409.982 323.383 407.97C324.094 407.015 325.485 405.814 325.852 404.715",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M314.519 429.129C314.011 429.382 316.011 427.131 316.173 426.934C319.23 423.21 322.224 419.554 325.52 416.035C327.836 413.562 334.474 405.874 332.076 408.268",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M319.186 433.121C319.532 431.57 322.535 429.341 323.57 428.202C326.428 425.054 329.226 421.864 331.829 418.499C333.513 416.323 337.836 409.43 336.966 412.039",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M327.631 434.23C326.644 434.23 327.398 433.921 327.854 433.466C330.603 430.721 333.344 427.943 336.027 425.132C338.424 422.621 340.776 420.022 343.46 417.808C343.94 417.412 344.41 416.977 344.744 416.477",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M333.188 438.892C332.629 438.954 332.63 439.325 333.336 438.423C336.568 434.292 340.416 430.713 344.152 427.056C347.232 424.041 356.78 415.341 353.412 418.031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M345.856 436.23C343.039 438.418 350.361 430.676 352.943 428.216C355.424 425.853 357.473 423.119 359.857 420.696C360.191 420.357 362.075 418.491 361.857 419.142",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M352.966 436.673C352.458 436.958 352.575 437.087 352.966 436.624C355.145 434.047 357.515 431.618 359.831 429.165C362.466 426.373 370.351 417.982 367.634 420.695",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M361.412 434.452C360.977 434.506 361.593 434.271 361.918 433.946C364.692 431.176 367.597 428.532 370.178 425.575C371.374 424.204 372.571 421.842 374.154 420.939C374.393 420.803 373.777 421.345 373.635 421.58",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M367.19 435.564C367.251 436.048 367.652 435.607 367.771 435.416C369.199 433.112 371.475 431.152 373.339 429.202C374.594 427.889 375.443 426.283 376.623 424.936C376.843 424.685 376.578 425.089 376.525 425.355",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M373.636 435.785C373.432 435.811 373.4 435.996 373.574 435.822C374.947 434.452 376.162 432.917 377.55 431.544C378.996 430.113 380.345 428.54 381.859 427.18C382.059 427 382.923 426.289 382.303 426.909",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M379.858 435.119C379.144 436.633 381.902 433.688 382.031 433.566C382.398 433.216 386.197 429.851 385.636 429.571",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M385.857 435.341C385.857 438.005 390.144 432.931 390.524 432.456",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2769 376.09C58.3692 376.827 59.8857 374.428 59.9191 374.376C61.4611 371.966 62.6902 369.369 64.2774 366.991",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4988 381.857C58.6556 385.695 68.8791 373.06 72.3391 368.875C77.8304 362.233 93.232 341.457 88.0564 348.347",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5009 378.308C75.5105 378.913 84.1238 364.666 85.2178 363.144C87.9164 359.39 90.8056 355.796 93.6383 352.147C94.0701 351.59 95.5448 350.285 94.2803 350.79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3886 380.748C83.0856 377.171 86.0003 374.023 88.2286 370.762C92.021 365.213 96.1266 359.894 99.8592 354.303C102.15 350.872 104.467 347.46 106.798 344.057C107.447 343.11 108.175 341.711 106.946 343.244",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5009 385.411C86.5299 385.585 86.7364 385.146 86.8219 384.992C88.103 382.69 89.63 380.512 91.1433 378.359C95.3948 372.311 99.5486 366.261 103.589 360.063C106.537 355.539 109.647 351.134 112.503 346.55C114.117 343.96 112.724 346.245 112.059 347.241",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5017 388.293C92.7627 388.228 92.7642 387.912 92.8721 387.701C94.0605 385.383 95.6687 383.204 97.144 381.068C101.399 374.909 106.207 369.152 110.367 362.92C112.963 359.033 115.544 355.172 118.207 351.331C119.191 349.913 121.332 347.864 121.837 346.35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3913 393.619C99.3913 394.592 100.089 392.717 100.157 392.584C103.478 386.044 108.094 380.132 112.355 374.189C115.733 369.479 119.426 364.904 122.578 360.035C122.984 359.409 124.63 357.253 124.282 356.559",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M105.392 399.168C107.659 396.904 109.146 393.55 110.898 390.908C115.644 383.753 120.353 376.566 124.899 369.283C127.691 364.809 130.683 360.48 133.295 355.893C133.726 355.136 135.126 354.109 134.456 353.551C134.406 353.51 134.092 353.865 134.061 353.896",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M128.505 380.527C128.461 380.876 128.398 380.641 128.603 380.281C130.621 376.729 133.102 373.451 135.493 370.146C137.78 366.983 140.21 363.937 142.53 360.801C142.547 360.778 144.199 358.932 143.172 359.445",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M138.06 380.527C136.65 381.319 138.241 380.004 138.887 378.998C141.427 375.045 143.977 371.087 146.777 367.31C146.915 367.125 149.07 364.736 147.838 365.658",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M145.839 384.965C145.155 383.21 148.293 379.952 149.037 378.875C151.537 375.254 153.975 371.536 156.729 368.099",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M148.95 389.846C148.797 389.999 148.293 390.407 148.432 390.24C149.897 388.485 151.101 386.519 152.37 384.618C154.746 381.06 157.219 377.721 160.013 374.484C160.79 373.584 161.568 372.685 162.359 371.796C162.521 371.614 162.013 372.141 161.84 372.314",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M147.617 405.604C146.653 406.507 148.084 404.026 148.21 403.804C151.863 397.375 156.558 391.552 160.68 385.422C163.791 380.795 173.19 366.97 169.841 371.429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M157.173 403.606C157.173 403.62 158.172 401.948 158.346 401.683C160.787 397.966 163.137 394.264 165.84 390.735",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M181.62 373.648C181.634 373.72 182.286 372.365 182.299 372.341C183.186 370.661 184.176 369.046 185.176 367.434",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M187.176 375.199C187.347 373.495 189.525 371.177 190.349 369.91C194.933 362.864 200.209 356.319 205.14 349.518C208.969 344.238 220.577 328.498 216.956 333.922",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M208.511 338.807C208.93 337.274 210.931 335.479 211.882 334.344C213.245 332.715 214.561 330.991 216.067 329.487",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M203.621 365.879C203.505 366.002 202.392 367.259 202.892 366.606C207.081 361.137 211.43 355.823 215.795 350.492C220.131 345.196 225.123 339.965 228.734 334.144C229.014 333.694 230.406 330.988 229.623 332.813",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M209.844 370.763C209.209 370.693 209.702 370.133 209.893 369.826C213.621 363.87 218.678 358.567 222.968 352.997C227.009 347.752 231.007 342.467 234.772 337.019C234.847 336.91 236.462 334.3 236.068 335.478",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M211.178 375.426C210.989 375.426 211.5 374.705 211.635 374.526C215.303 369.641 218.982 364.762 222.636 359.866C227.613 353.198 232.526 346.499 237.365 339.733C237.442 339.626 239.906 336.029 239.97 336.072C239.987 336.083 238.832 337.575 238.736 337.699",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M220.956 376.532C220.075 376.422 221.681 374.898 222.215 374.189C226.382 368.658 230.98 363.638 235.512 358.421C238.038 355.513 240.586 352.575 242.92 349.507C243.436 348.829 244.56 347.173 243.402 348.792",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M225.845 384.075C226.074 382.814 227.378 381.318 228.042 380.327C230.721 376.333 233.83 372.606 236.808 368.837C239.585 365.323 242.39 361.834 245.18 358.332C246.525 356.643 248.154 355.012 248.958 353.006",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M234.513 385.41C234.568 384.87 234.968 384.398 235.279 383.979C237.098 381.528 238.953 379.103 240.81 376.681C243.536 373.124 246.073 369.407 248.848 365.893C251.537 362.488 255.039 359.743 256.737 355.672",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M264.071 362.107C264.015 362.609 266.906 358.776 267.404 358.112",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07 367.432C268.212 365.736 269.632 364.143 270.515 362.772",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4993 407.6C58.4993 407.81 58.7215 407.575 58.845 407.452C59.7941 406.504 60.6553 405.447 61.6107 404.493",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6097 414.703C59.1729 414.648 63.0214 410.631 63.0297 410.622C66.8461 406.509 70.9059 402.815 75.1665 399.169",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1655 427.574C58.8777 427.87 57.6237 429.418 58.6222 428.326C60.7369 426.013 62.3763 423.244 64.4005 420.842C68.935 415.461 74.3345 410.731 79.1671 405.604",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M66.055 430.46C64.0677 431.73 65.984 429.524 66.5242 428.931C72.6635 422.187 79.1621 415.818 85.6122 409.377",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6117 431.124C73.8061 431.701 74.5704 430.907 75.5624 429.718C81.1715 422.997 87.5371 416.98 93.391 410.485",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6114 432.456C77.1058 438.14 95.7372 420.122 102.28 414.48",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M90.724 434.899C90.5037 434.836 97.606 428.111 97.9838 427.773C102.442 423.774 106.802 419.446 110.726 414.926",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M106.947 429.57C106.852 429.665 105.756 430.823 106.107 430.359C108.713 426.921 111.721 423.772 114.614 420.582C119.303 415.415 123.945 410.204 128.739 405.134C131.994 401.691 135.831 398.269 138.061 394.063",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M124.948 401.831C125.95 401.706 128.058 398.726 128.726 398.058",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M114.281 433.788C113.188 433.652 115.138 431.742 115.787 430.854C119.167 426.227 123.048 421.813 126.998 417.662C131.476 412.955 135.963 408.238 140.283 403.385",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M121.837 433.345C127.628 426.92 143.467 406.533 139.172 414.038",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M130.504 434.012C130.479 434.004 136.688 426.271 137.245 425.628C138.742 423.899 140.177 422.118 141.715 420.425C142.092 420.009 142.551 419.669 142.727 419.143",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M139.395 433.345C139.332 433.464 138.795 434.199 139.049 433.691C140.152 431.488 141.987 429.576 143.568 427.723C144.051 427.158 149.137 421.325 149.396 421.584",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M147.617 432.901C145.264 434.957 150.629 427.171 153.173 425.356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M152.728 434.896C152.651 434.983 152.232 435.619 152.42 435.389C154.092 433.348 155.444 430.849 156.951 428.682",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M161.619 432.899C161.915 431.272 163.923 429.635 164.952 428.46",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M168.063 432.677C167.237 433.502 169.734 430.231 170.063 429.792",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M174.731 432.679C174.555 432.701 174.293 433.044 174.509 432.802C175.552 431.63 176.423 430.15 177.398 428.906",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M181.175 434.231C180.316 434.123 183.419 430.036 183.619 429.792",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M187.176 432.233C186.417 432.328 188.97 429.31 189.398 428.682",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M192.509 433.564C192.509 434.248 193.677 430.764 193.842 430.235",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M164.507 416.7C164.507 417.329 164.855 416.808 165.124 416.502C167.174 414.173 169.248 412.03 171.618 410.042",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M168.285 418.917C166.15 420.782 171.875 414.523 173.841 412.481",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M172.063 423.579C173.055 421.845 174.549 420.286 175.791 418.747C178.673 415.175 181.603 411.643 184.484 408.07C187.505 404.321 190.47 400.416 192.953 396.283",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M179.842 423.58C181.114 420.913 183.076 418.58 184.953 416.318C187.887 412.785 190.797 409.245 193.695 405.679C197.118 401.465 200.645 397.347 203.844 392.955",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M190.286 421.804C189.968 421.759 190.642 420.812 190.706 420.719C194.291 415.5 198.888 410.739 203.176 406.097C206.996 401.962 210.938 398.083 214.066 393.398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M198.066 424.023C198.146 423.309 199.498 422.306 199.869 421.902C203.511 417.938 207.143 413.964 210.722 409.943C215.619 404.442 220.643 399.046 225.624 393.62",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M204.955 428.018C201.412 431.998 211.344 419.485 214.635 415.294C219.454 409.158 224.988 403.243 228.957 396.505",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 433.343C209.117 433.343 208.97 433.526 209.091 433.405C211.918 430.582 214.131 426.677 216.524 423.492C222.499 415.536 228.7 407.743 234.735 399.833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M221.695 432.267C221.675 432.44 221.218 432.964 221.388 432.757C225.524 427.71 229.103 422.208 233.411 417.268C239.951 409.77 247.55 403.01 252.866 394.518",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M231.643 431.823C231.078 431.753 232.032 430.584 232.11 430.474C235.406 425.777 239.141 421.405 242.684 416.898C246.703 411.787 250.323 405.838 255.298 401.58",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M240.044 436.901C239.562 436.84 240.206 435.92 240.315 435.748C242.849 431.744 246.263 428.14 249.329 424.539C253.168 420.031 257.337 415.861 260.825 411.073",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M251.097 433.367C251.14 432.938 251.424 432.64 251.699 432.325C253.639 430.101 255.599 427.895 257.533 425.666C261.47 421.126 265.014 416.011 269.446 411.954",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M259.277 435.8C258.75 435.65 259.692 434.773 260.026 434.341C262.746 430.817 265.699 427.465 268.611 424.1C270.54 421.871 272.791 418.125 275.415 416.815",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M268.342 437.123C267.446 436.117 278.845 423.544 280.279 422.112",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M275.857 436.241C275.162 436.327 275.778 435.863 276.274 435.21C277.835 433.157 279.658 431.266 281.42 429.385C281.697 429.089 282.268 428.919 282.268 428.514",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M281.385 437.786C279 439.87 288.67 427.426 286.912 430.06",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M289.121 435.578C289.238 434.418 291.054 432.267 292.216 432.267",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M296.196 435.356C296.905 434.898 297.281 433.842 297.743 433.149",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M136.916 129.307C134.403 131.537 141.227 124.093 143.852 121.995",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M135.117 137.26C132.897 139.477 139.236 132.525 141.348 130.205C143.579 127.752 145.732 125.202 148.348 123.15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M133.96 142.776C133.884 142.852 133.491 143.16 133.768 143.16C133.825 143.16 134.107 143.077 134.06 143.132C133.466 143.825 135.251 141.747 135.859 141.065C138.259 138.371 140.873 135.912 143.481 133.426C145.213 131.774 147.648 130.034 148.99 128.024",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M141.41 144.442C141.41 143.136 143.186 141.898 144.001 141.085C145.667 139.421 147.341 137.777 148.86 135.976",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M206.667 115.325C206.488 114.987 206.153 114.885 206.553 115.196C207.232 115.724 208.339 115.763 209.136 115.937C210.536 116.243 211.812 117.142 213.019 117.89C215.209 119.247 216.966 120.879 218.942 122.479C220.57 123.797 222.408 125.734 223.559 127.503C224.82 129.441 225.695 131.719 226.706 133.796C227.629 135.689 228.147 137.819 228.947 139.76C229.713 141.617 230.248 143.981 230.303 145.982C230.345 147.492 230.56 148.999 230.56 150.485C230.56 151.02 230.303 151.47 230.303 151.946C230.303 152.478 230.402 152.622 229.918 152.139",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M207.438 144.957C207.429 144.88 207.033 144.684 207.331 144.722C208.488 144.866 209.933 145.961 210.978 146.468C212.927 147.412 215.022 148.083 217.08 148.748C218.286 149.138 219.349 149.741 220.605 149.959C221.754 150.159 223.152 150.428 224.238 150.857C225.156 151.22 226.149 151.629 226.992 152.14C227.607 152.513 228.441 152.493 229.083 152.838C229.532 153.08 230.059 153.244 230.496 153.487C231.736 154.174 229.92 152.04 229.79 151.883",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M64.582 386.488C64.384 388.07 57.3154 384.002 57.2985 383.994C52.5805 381.585 47.8145 381.655 43.6816 385.294C37.2984 390.914 34.9532 400.702 42.0983 406.41",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3151 405.465C39.2769 405.465 36.0867 408.978 34.9908 413.511C33.146 421.143 38.6649 421.689 44.9484 420.644",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5826 421.908C39.9725 422.418 37.3743 433.933 43.0492 435.822",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9407 346.017C60.4626 346.017 59.6708 345.617 59.3573 345.226C58.6664 344.364 55.9293 344.215 54.8535 343.803C49.4859 341.75 41.6056 341.467 36.3106 343.803C30.0886 346.548 23.6039 350.558 22.553 357.787C21.7883 363.048 26.787 366.509 31.1735 368.152",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8061 369.416C28.8821 369.416 26.0334 369.721 23.2559 370.681C20.3692 371.679 15.3117 374.802 14.3891 377.796C13.0091 382.274 10.7994 385.56 15.3391 389.338",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3398 389.654C13.494 391.292 10.8157 391.15 9.32304 393.8C7.2472 397.485 6.8285 403.417 10.2555 406.554C11.1863 407.406 6.43503 407.746 5.83965 408.135C1.10949 411.227 -0.14495 419.395 2.03959 424.122",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1824 370.363C52.6886 370.486 52.5246 371.622 52.3027 372.014C49.2768 377.36 44.686 382.042 40.8322 386.806",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6139 390.286C37.372 390.534 35.9878 392.822 35.3768 393.554C32.7559 396.692 29.9926 399.769 27.8471 403.251",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5657 396.612C34.686 401.484 30.6359 407.288 26.8989 413.055",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9817 407.991C33.8329 413.138 29.4538 418.201 25.9482 423.802",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M37.349 419.061C33.7615 422.643 30.741 427.198 28.4822 431.709",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8813 423.17C39.7972 423.926 38.9264 424.842 38.5442 425.419C36.0927 429.118 33.6334 432.802 31.6478 436.767",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokect);
export default __webpack_public_path__ + "static/media/rokect.ebb2d1fa526d475d16165d1a3498d712.svg";
export { ForwardRef as ReactComponent };